import { render, staticRenderFns } from "./accessConfig.vue?vue&type=template&id=82a0432c&scoped=true"
import script from "./accessConfig.vue?vue&type=script&lang=js"
export * from "./accessConfig.vue?vue&type=script&lang=js"
import style0 from "./accessConfig.vue?vue&type=style&index=0&id=82a0432c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a0432c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82a0432c')) {
      api.createRecord('82a0432c', component.options)
    } else {
      api.reload('82a0432c', component.options)
    }
    module.hot.accept("./accessConfig.vue?vue&type=template&id=82a0432c&scoped=true", function () {
      api.rerender('82a0432c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/role_manage/form/accessConfig.vue"
export default component.exports